/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */

export type ModeledAdjustmentActionDtoAdjustmentType =
  (typeof ModeledAdjustmentActionDtoAdjustmentType)[keyof typeof ModeledAdjustmentActionDtoAdjustmentType];

export const ModeledAdjustmentActionDtoAdjustmentType = {
  ADMIT: 'ADMIT',
  YIELD: 'YIELD',
} as const;
